module.exports = __webpack_public_path__ + "img/62.5d4ea47a.jpg";